import { deleteApi, getApi, postApi, putApi } from "./general.service";

export const getVideoTutorials = async (params) => {
  const response = await getApi("/videoTutorial", { params });
  return response;
};

/** GET single tutorial by id. Use raw=true to get full document with title[] for editing. */
export const getVideoTutorial = async (id, options = {}) => {
  const params = { id };
  if (options.params?.raw) params.raw = "true";
  const response = await getApi("/videoTutorial", { params });
  return response;
};

export const createVideoTutorial = async (data) => {
  const response = await postApi("/videoTutorial", data);
  return response;
};

export const updateVideoTutorial = async (data) => {
  const response = await putApi("/videoTutorial", data);
  return response;
};

export const deleteVideoTutorial = async (id) => {
  const response = await deleteApi(`/videoTutorial?_id=${id}`);
  return response;
};

/**
 * Upload video file for a tutorial (multipart).
 * @param {string} videoTutorialId - _id of the tutorial
 * @param {string} lang - language code (e.g. 'en', 'es')
 * @param {File} file - video file
 */
export const uploadVideoTutorialMedia = async (videoTutorialId, lang, file) => {
  const formData = new FormData();
  formData.append("videoTutorialId", videoTutorialId);
  formData.append("lang", lang);
  formData.append("file", file);
  const token = JSON.parse(localStorage?.getItem("user") || "{}")?.token;
  const response = await fetch(`${process.env.REACT_APP_API_URL}/videoTutorial/video`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });
  if (!response.ok) throw new Error(response.statusText);
  return response.json();
};
